import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=1e29a61c&scoped=true"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=1e29a61c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e29a61c",
  null
  
)

export default component.exports